export default "__VITE_ASSET__DtgDOG$S__"